import styled from "styled-components";

export const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 7px;
  flex-wrap: nowrap;
  color: ${({ clr }) => clr};
`;

export const TimeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: inherit;
  width: 40px;
`;

export const Count = styled.div`
  color: inherit;
  font-size: 20.67px;
  font-weight: 700;
`;

export const Label = styled.div`
  color: inherit;
  font-size: 11.274px;
  font-weight: 700;
  line-height: 150%;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  width: 1px;
  height: 30px;
  background: ${({ theme }) => theme.border.black15};
`;
